import React from 'react';
import { Link } from 'react-router';


export default class Dashboard extends React.Component {
	render() {
		return (
			<div className="container">
				<div className="row">
					<div className="col-3">
							<div className="card card-block text-xs-center">
								<Link to="/reports/products" className="card-link">
									Productos
								</Link>
							</div>
					</div>
					<div className="col-3">
							<div className="card card-block text-xs-center">
								<Link to="/reports/evaluations" className="card-link">
									Evaluaciones
								</Link>
							</div>
					</div>
					<div className="col-3">
							<div className="card card-block text-xs-center">
								<Link to="/reports/surveys" className="card-link">
									Encuestas
								</Link>
							</div>
					</div>
					<div className="col-3">
							<div className="card card-block text-xs-center">
								<Link to="/reports/accompaniment" className="card-link">
									Acompañamiento
								</Link>
							</div>
					</div>
				</div>
			</div>
		);
	}
}


/** WEBPACK FOOTER **
 ** ./src/components/presentation/reports/Dashboard.jsx
 **/